module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-apotheek-rodenbach-machelen-zulte-1.08787444.jpg";